import React, { useContext, useEffect, useState } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, MenuItem, Paper, Select, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CountryDataType, FiscalYearListType, useInit } from '../DataFetch/useInit';
import { useSearchCountryData } from '../DataFetch/useSearchCountryData';
import { CountryMasterEdit } from './CountryMasterEdit';
import { GetCountryMasterCSV } from '../DataFetch/ManagementAPI';
import { SaveCSVWithBOM } from '../Utility/SaveCSVWithBOM';
import { useErrorDialog } from '../Component/useErrorDialog';
import { useCountryMasterUploadDialog } from '../Component/useCountryMasterUploadDialog';
import { SessionContext } from '../ManagementRoot';

export function CountryMaster() {

    const {init} = useInit();

    const [currentYear, setCurrentYear] = useState(init?.fiscalyear.toString());

    const {countryData, isLoading, mutate} = useSearchCountryData(currentYear);

    const [editing, setEditing] = useState<boolean>(false);

    const [editData, setEditData] = useState<CountryDataType | undefined>(undefined);

    const {openErrorDialog, ErrorDialog} = useErrorDialog();

    const {openUploadDialog, UploadDialog, isComplete} = useCountryMasterUploadDialog();

    const ConfirmSession = useContext(SessionContext);

    useEffect(() => {
        if(isComplete) {
            mutate();
        }
    },[isComplete, mutate])

    async function DownloadCSV() {

        if(!await ConfirmSession()) {
            return;
        }

        GetCountryMasterCSV(currentYear)
        .then(res => {
            res !== undefined ? SaveCSVWithBOM(`国マスタ${currentYear}.csv`, res) : openErrorDialog();
        })
    }

    async function OpenEditor(data:CountryDataType | undefined) {

        if(!await ConfirmSession()) {
            return;
        }

        setEditData(data);
        setEditing(true);
    }

    function CompleteEdit() {
        setEditing(false);
        mutate();
    }

    function CountryList() {
        return(
            <>
                <TableContainer sx={{maxHeight:600}}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>国名</TableCell>
                                <TableCell>国名(英語)</TableCell>
                                <TableCell>地域ID</TableCell>
                                <TableCell>国コード2桁</TableCell>
                                <TableCell>国コード3桁</TableCell>
                                <TableCell>ドロップダウンリスト表記</TableCell>
                                {/* <TableCell>対象年度</TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {countryData?.map((item:CountryDataType, index:number) => (
                                <TableRow key={index} hover onClick={() => OpenEditor(item)}>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{item.country_name}</TableCell>
                                    <TableCell>{item.country_name_en}</TableCell>
                                    <TableCell>{item.region_id}</TableCell>
                                    <TableCell>{item.country_code2}</TableCell>
                                    <TableCell>{item.country_code3}</TableCell>
                                    <TableCell>{item.dropdown_disp}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" size="small" onClick={() => OpenEditor(item)}>編集</Button>
                                    </TableCell>
                                    {/* <TableCell>{item.target_year}</TableCell> */}
                                </TableRow>     
                            ))} 
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    }

    function CountryListWindows() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Box m={2}>
                            <Grid2 container direction="row" maxWidth="xl" justifyContent="center" alignItems="center" spacing={2}>
                                <Grid2 xs={12} sm="auto">
                                    <Typography variant="body1">
                                        対象年度
                                    </Typography>
                                </Grid2>
                                <Grid2 xs={12} sm="auto">
                                    <Select
                                        defaultValue={init?.fiscalyear.toString()}
                                        onChange={e => e.target.value !== currentYear ? setCurrentYear(e.target.value) : ""}
                                        value={currentYear}
                                    >
                                        {
                                            init?.fiscal_year_list.map((value:FiscalYearListType, index:number) =>(
                                                <MenuItem key={index} value={value.target_year.toString()}>
                                                    {value.target_year}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </Grid2>
                                <Grid2 xs={12} sm="auto">
                                    <Button variant="contained" onClick={DownloadCSV}>
                                        CSV出力
                                    </Button>
                                </Grid2>
                                <Grid2 xs={12} sm="auto">
                                    <Button variant="contained" onClick={openUploadDialog}>
                                        データ登録
                                    </Button>
                                </Grid2>
                                
                            </Grid2>
                        </Box>
                    </Paper>
                </Grid2>
                <Grid2 xs={12}>
                    <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                        {!isLoading ? <CountryList/> : ""}
                    </Paper>
                </Grid2>

                <UploadDialog/>
            </>
        );
    }

    function EditWindow() {
        return(
            <>
                <Grid2 xs={12}>
                    <Paper>
                        <Box m={2} p={1}>
                            <CountryMasterEdit 
                                editData={editData}
                                CompleteEdit={CompleteEdit}
                                setEditing={setEditing}
                            />
                        </Box>
                    </Paper>
                </Grid2>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                国マスタ
            </Typography>
            
            {editing ? <EditWindow/> : <CountryListWindows/>}

            <ErrorDialog/>
        </>
    );
}